// 用户答题模块
export default {
  UserAnswer: {
    YouHaveAlreadyAnswered: 'Anda telah menjawab sebelum ini',
    Question: 'Soalan',
    DoYouWantToContinue: 'Adakah anda hendak terus menjawab?',
    PreviewOrPrint: 'Pratonton atau cetak',
    ReAnswerQuestions: 'Menjawab sekali lagi',
    ContinueAnsweringQuestions: 'Terus menjawab',
    TheQuestionnaireWillBeOpen: 'Soal selidik ini akan dibuka, sila buka halaman tersebut semasa itu!',
    EnterQuestionnairePassword: 'Sila masukkan kata laluan soal selidik',
    EnterPassword: 'Sila masukkan kata laluan',
    Determine: 'Pastikan',
    ShareTo: 'Kongsi di',
    ClickToView: 'Klik untuk melihat',
    Statistics: 'Statistik',
    ShareOnWeChatMoments: 'Kongsi di Detik Wechat',
    WantToContinue: 'Hendak terus menjawab?',
    NoActionTaken: 'Sistem akan menyerahkan jawapan secara automatik Sekiranya tiada operasi untuk masa yang lama',
    SubmitTo: 'Hantar',
    YouHaveLeftTheExam: 'Anda telah meninggalkan soal selidik',
    Times: 'Bilangan kali',
    Leave: 'Bilangan kali meninggalkan soal selidik',
    WillBeForcedToSubmitThePaper: 'Akan akan mengakibatkan penyerahan mandatori',
    NeedToOpenOnWeChat: 'Anda perlu membukanya di dalam Wechat untuk mengambil bahagian',
    ScanQRCodeUsingWeChat: 'Imbas Kod QR dengan menggunakan Wechat',
    CopyThisPageAddress: 'Salin alamat laman web dan membukakannya dengan menghantar mesej di Wechat',
    WeChatLoginRequired: 'Log masuk ke Wechat untuk mengambil bahagian',
    OneClickLogin: 'Log masuk dengan 1 klik',
    Loading: 'Sedang dimuatkan...',
    RateTheOptions: 'Sila nilai opsyen',
    SelectOptions: 'Sila pilih opsyen',
    SelectDate: 'Sila pilih tarikh',
    SortAllOptions: 'Sila isih semua opsyen',
    SelectedPosition: 'Sila pilih lokasi',
    EnsureCompleteAnswers: 'Sila pastikan jawapan adalah lengkap',
    Timing: 'Sila pilih masa',
    ChooseAnOption: 'Sila pilih satu opsyen',
    CheckTheAnswers: 'Sila semak jawapan',
    InputContent: 'Sila masukkan kandungan',
    UploadFiles: 'Sila muat naik dokumen',
    SelectSpecificGravity: 'Sila pilih perkadaran',
    StatisticsPageToBeImproved: 'Laman statistik akan dilengkapkan',
    UploadFailed: 'Muat naik gagal!',
    Submitting: 'Sedang dihantar...',
    Prompt: 'Gesaan',
    TheAnswerIsNotRecorded: 'Halaman pratonton, jawapan tidak akan direkodkan.',
    IsOver: 'Tamat',
    NothingInTheWorld: 'Tiada apa di sini~',
    Staging: 'Penyimpanan sementara',
    ScanQRCodeToAnswerQuestions: 'Imbas kod QR untuk menjawab',
    Report: 'Laporkan',
    DongfangAixueProvidesSupport: 'Disokong oleh SurveyTree',
    Print: 'Cetak',
    DataPreparationInProgress: 'Data sedang disediakan, dijangka siap dalam 5 minit. Beralih ke',
    CanViewProgress: 'untuk semak status muat turun',
    MyDownload: 'Muat turun saya',
    QuotaIsFull: 'Kuota telah penuh',
    SuccessfullyStaged: 'Penyimpanan sementara berjaya',
    PleaseEnter: 'Sila masukkan',
    Other: 'Lain-lain',
    PleaseSelect: 'Sila pilih',
    Small: 'Kecil',
    Middle: 'Sederhana',
    TotalSpecificGravity: 'Jumlah perkadaran',
    Big: 'Besar',
    Year: 'Tahun',
    Month: 'Bulan',
    Day: 'Hari',
    GetLocation: 'Klik untuk dapatkan lokasi',
    YourLocation: 'Lokasi anda',
    SearchAddress: 'Masukkan kata kunci untuk mencari alamat',
    Clear: 'Padamkan',
    SelectAProvince: 'Sila pilih wilayah/negeri',
    SelectACity: 'Sila pilih bandar',
    SelectADistrict: 'Sila pilih daerah',
    DetailedAddress: 'Alamat terperinci',
    UploadFileImages: 'Muat naik gambar',
    UploadFilesWithin10MB: 'Pilih dokumen untuk muat naik(Di bawah 10MB)',
    TheFileSizeCannotExceed10MB: 'Dokumen tidak boleh melebihi 10MB!',
    MaximumNumberOfTimes: 'Telah sampai bilangan muat naik yang maksima',
    FailedToUploadFile: 'Muat naik gagal',
    SelectCascadingOption: 'Sila pilih opsyen lata',
    SelectTheFollowingImage: 'Sila pilih gambar berikut',
    MaximumSelection: 'Bilangan pilihan maksima',
    Options: 'Opsyen',
    MinimalSelection: 'Bilangan pilihan minima',
    CheckTheAnswers: 'Sila semak jawapan',
    OnlineQuestionnaire: 'Soal selidik dalam talian',
    ExplanationScores: 'Explanation of scores:',
    ExplanationScoresA: 'If your score on a scale is',
    ExplanationScoresB: 'you have a mild preference for',
    ExplanationScoresC: 'dimension but  you are essentially well balanced',
    ExplanationScoresD: 'you have a moderate preference for',
    ExplanationScoresE: 'dimension of the scale  and will learn more easily in a teaching environment which favors that dimension.',
    ExplanationScoresF: 'you have a strong preference for ',
    ExplanationScoresG: 'dimension of the scale.  You may have real difficulty learning in an environment which does not support that  preference.'
  },
};